import styles from './TimeInfo.module.scss';
import { useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useTranslation } from 'react-i18next';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';

export interface TimeInfoProps {
  label: string;
  timestamp?: string;
}

export default function TimeInfo({ label, timestamp }: TimeInfoProps) {
  const { t } = useTranslation();
  const { parseFromIso, showTimeAndDate } = useLocaleFormatter();

  const isLoading = timestamp === undefined;

  const ts = useMemo(() => {
    return timestamp ? parseFromIso(timestamp) : null;
  }, [parseFromIso, timestamp]);

  return (
    <div className={styles.container}>
      <div className={styles.label}>
        {!isLoading ? label : <Skeleton width="50px" height="16px" />}
      </div>
      <div id="hoverOpener" className={styles.value}>
        {!isLoading ? (
          ts ? (
            showTimeAndDate(ts)
          ) : (
            t('Never')
          )
        ) : (
          <Skeleton width="120px" height="20px" />
        )}
      </div>
    </div>
  );
}
